import { Center, Text, Stack, Button, Group, Title, Container, useMantineTheme } from '@mantine/core';
import { IconHome, IconArrowLeft, IconAlertCircle } from '@tabler/icons-react';
import React from 'react';
import { Link } from 'react-router';

export interface NotFoundPageProps {
    whatNotFound?: string;
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({ whatNotFound = 'Page' }) => {
    const theme = useMantineTheme();

    return (
        <Container size="sm" py="xl">
            <Center>
                <Stack align="center" gap="xl">
                    <Stack align="center" gap="md">
                        <IconAlertCircle size={80} color={theme.colors.orange[6]} />
                        <Title order={1} size="h2" ta="center">
                            404
                        </Title>
                        <Title order={2} size="h3" ta="center" c="dimmed">
                            {whatNotFound} Not Found
                        </Title>
                        <Text size="lg" ta="center" c="dimmed" maw={400}>
                            The {whatNotFound.toLowerCase()} you're looking for doesn't exist or has been moved.
                        </Text>
                    </Stack>

                    <Group gap="md" justify="center">
                        <Button variant="outline" leftSection={<IconArrowLeft size={16} />} component={Link} to="..">
                            Back
                        </Button>
                        <Button leftSection={<IconHome size={16} />} component={Link} to="/">
                            Home
                        </Button>
                    </Group>
                </Stack>
            </Center>
        </Container>
    );
};
